import { Button } from "@/components/ui/atoms/Button/Button";
import AdminSettingsDisplayCard from "./AdminSettingsDisplayCard";

type AdminSettingsDisplaySelectInterfaceProps = {
  pageTitle: string;
  pageDescription: string;
  value: string;
  onChange: (value: string) => void;
  options: SelectInterfaceOption[];
  backToHomeAction: () => void;
}

export type SelectInterfaceOption = {
  title: string;
  preview: string;
  value: string;
}

const AdminSettingsDisplaySelectInterface = ({ pageTitle, pageDescription, value, onChange, options, backToHomeAction }: AdminSettingsDisplaySelectInterfaceProps): JSX.Element => {
  return (
    <>
      <div className="flex flex-row items-center bg-admin-darkblue-300 pl-1w">
        <Button className="bg-admin-darkblue-300 border border-white h-[40px]" onClick={backToHomeAction}>Retour</Button>
        <h2 className="text-header3 text-white p-2w">{pageTitle}</h2>
      </div>
      <div className="flex flex-col gap-2w p-2w">
        <span className='text-body1 font-medium'>{pageDescription}</span>
        <div className="flex flex-col flex-wrap justify-center md:flex-row gap-2w w-full">
          {options.map(option => (
            <AdminSettingsDisplayCard
              key={option.value}
              title={option.title}
              value={option.value}
              preview={option.preview}
              selected={value === option.value}
              onSelect={onChange}
            />
          ))}
        </div>
      </div>
    </>
  )
}

export default AdminSettingsDisplaySelectInterface;